
// imports
import { useState } from "react";

import { LangContext } from "./LangContext.jsx";

// constants 
import { UrlClient } from "../components/constants/constants.js";


export const LangProvider = ({ children }) => {

  const LANGUAGE = ["www.gmd-customer.com", "gmd-customer.com"].includes(UrlClient) ? (localStorage.getItem("lang") ?? window.navigator.language.slice(0, 2)) : "es";

  // state definition
  const [lang, setLang] = useState(LANGUAGE);

  const handleChangeLang = (newLang = "") => {
    setLang(newLang);
    localStorage.setItem("lang", newLang);
  };


  return (
    <LangContext.Provider value={{ lang, handleChangeLang }}>
      {children}
    </LangContext.Provider>
  );
};